import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { AuthService, SamlRequest } from './../../../services/auth/auth.service';
import { SharedService } from './../../../services/shared/shared.service';
import { RoutingService } from '../../../services/routing/routing.service';
import { ConfigService } from '../../../services/config/config.service';
import { ApiService } from '../../../services/apiservice/apiservice.service';
import { switchMap } from 'rxjs';

@Component({
  selector: 'app-saml',
  templateUrl: './saml.component.html',
  styleUrls: ['./saml.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SamlComponent implements OnInit {
  constructor(
    private _activatedRoute: ActivatedRoute,
    private _authService: AuthService,
    private _sharedService: SharedService,
    private _routingService: RoutingService,
    private _configService: ConfigService,
    private _apiService: ApiService,
  ) {}

  ngOnInit() {
    const url = `${this._routingService.baseUri}/sso/getinfo.php`;
    this._activatedRoute.queryParams
      .pipe(
        switchMap((q: Params) => {
          return this._apiService.get(url, { params: q });
        }),
        switchMap((r: SamlRequest) => {
          const payload = {
            samlKey: r.samlKey,
            samlData: r.samlData,
          };

          return this._authService.loginSaml(payload);
        }),
      )
      .subscribe({
        next: (userData) => {
          this._routingService.redirectAfterLogin(userData);
        },
        error: () => {
          this._sharedService.openSnackBar('Authentication failed');
        },
      });
  }
}
